export default "__VITE_ASSET__DAmoYui___"